import {
  Image,
  Paper,
  useMantineColorScheme,
  useMantineTheme,
} from '@mantine/core';
import horizontalLogo from './horizontal-trans.png';

export function Logo() {
  const { colorScheme } = useMantineColorScheme();
  const { colors } = useMantineTheme();

  return (
    <Paper
      h={'100%'}
      w="auto"
      withBorder={false}
      shadow="sm"
      bg={colorScheme === 'dark' ? colors.gray[6] : colors.gray[2]}
      p={1}
    >
      <Image
        radius="md"
        h={'100%'}
        src={horizontalLogo}
        w="auto"
        fit="contain"
      />
    </Paper>
  );
}
